import User from "./User";
import { customerLevels } from './variables';

export default class EditUser extends User {
    constructor({
        language,
        level,
        customerName,
        customerExternalId,
        availableProjects,
        selectedProjects,
        isAuthUserSuperadmin,
        superAdminPrivilegegroup,
        editingSelf,
        isSuperadmin,
        suppressEmails,
        tagSearch,
        timepickerMode,
        ...baseData
        } = {}) {
        super(baseData);

        this.language = language || 'en';
        this.level = level || customerLevels[1].value;
        this.customerName = customerName;
        this.customerExternalId = customerExternalId;
        this.availableProjects = availableProjects || [];
        this.selectedProjects = selectedProjects || [];
        this.isAuthUserSuperadmin = isAuthUserSuperadmin;
        this.superAdminPrivilegegroup = superAdminPrivilegegroup;
        if (this.superAdminPrivilegegroup) {
            this.superAdminPrivilegegroup.name = '!!! ' + this.superAdminPrivilegegroup.name + ' !!!';
        }
        this.editingSelf = editingSelf;
        this.isSuperadmin = isSuperadmin;
        this.suppressEmails = suppressEmails || 0;
        this.tagSearch = tagSearch || 0;
        this.timepickerMode = timepickerMode || 0;
    }

    getLevelDisplayText(value = this.level) {
        const match = customerLevels.find(l => l.value === value);
        if (match) return match.text;
        return null

    }

    updateLevel(newLevelText) {
        const newLevel = customerLevels.find(level => level.text === newLevelText);
        if (newLevel) {
            this.level = newLevel.value;
        }
    }

    hasProjectSelected(idToCheck) {
        if (!idToCheck) return !!this.selectedProjects.length;

        return this.selectedProjects.some(project => project.id === idToCheck)
    }

    findSelectedProject(id) {
        if (!id) return null;
        return this.selectedProjects.find(project => project.id === id);
    }

    findAvailableProject(id) {
        if (!id) return null;
        return this.availableProjects.find(project => project.id === id);
    }

    getAllProjects(sorted = false) {
        const projects = this.availableProjects.map(project => {
            const selected = this.hasProjectSelected(project.id);
            return {...project, value: project.id, text: project.name, selected};
        });
        if (this.isLdap) {
            return projects.filter(project => project.isLdap);
        }

        if (sorted) {
            return _.orderBy(projects, ['name'], ['asc']);
        }

        return projects;
    }

    getProjectNamesForDropDown() {
        const name = `${Lang.langGet('Manage groups in')} ${Lang.langGet('all projects')}`;
        const selectAllProject = {id: -1, name};

        return [
            selectAllProject,
            ...this.selectedProjects
        ];
    }

    updateProject(project) {
        if (_.isUndefined(project.id)) return;

        const index = this.selectedProjects.findIndex(selectedProject => selectedProject.id === project.id);
        if (index >= 0) {
            this.selectedProjects.splice(index, 1);
        } else {
            this.selectedProjects.push(project);
        }
    }

    updateGroup(groupKey, group) {
        if (_.isUndefined(group.id)) return;

        // super admin case
        if (group.id === 1 && groupKey === 'privilegegroups') {
            this.isSuperadmin = !this.isSuperadmin;
            return;
        }

        const selectedProject = this.findSelectedProject(group.projectId);

        const hasGroup = selectedProject[groupKey].some(g => g.id === group.id);
        if (hasGroup) {
            selectedProject[groupKey] = selectedProject[groupKey]
                .filter(groups => groups.id !== group.id);
            return;
        }

        selectedProject[groupKey].push(group);
    }

    hasPrivilegegroupSelected(project, id) {
        return project.privilegegroups.some(group => group.id === id);
    }

    updatePrivilegegroups(privilegegroup) {
        this.updateGroup('privilegegroups', privilegegroup);
    }

    getAllPrivilegegroupsForAProject(projectId, resolveFullName = false) {
        const selectedProject = this.findSelectedProject(projectId);
        const availableProject = this.findAvailableProject(projectId);

        return availableProject.privilegegroups.map(group => {
            const selected = this.hasPrivilegegroupSelected(selectedProject, group.id);
            if (resolveFullName) return {...group, name: `${availableProject.name} > ${group.name}`, selected};

            return {...group, selected};
        });
    };

    getPrivilegeGroupByProject(projectId, sorted) {
        if (projectId >= 0) {
            return this.getAllPrivilegegroupsForAProject(projectId);
        }

        const allGroups = [];

        if (this.isAuthUserSuperadmin) {
            allGroups.push({...this.superAdminPrivilegegroup, selected: this.isSuperadmin});
        }

        this.selectedProjects.map(project => {
            const privilegegroups = this.getAllPrivilegegroupsForAProject(project.id, true);
            allGroups.push(...privilegegroups);
        })

        if (sorted) {
            return _.orderBy(allGroups, ['name'], ['asc']);
        }

        return allGroups;
    }

    hasUsergroupsSelected(project, id) {
        return project.usergroups.some(group => group.id === id);
    }

    updateUsergroups(usergroup) {
        this.updateGroup('usergroups', usergroup);
    }

    getAllUsergroupsForAProject(projectId, resolveFullName = false) {
        const selectedProject = this.findSelectedProject(projectId);
        const availableProject = this.findAvailableProject(projectId);

        return availableProject.usergroups.map(group => {
            const selected = this.hasUsergroupsSelected(selectedProject, group.id);
            if (resolveFullName) return {...group, name: `${availableProject.name} > ${group.name}`, selected};

            return {...group, selected};
        });
    }

    getUsergroupsGroupedByProject(projectId, sorted) {
        if (projectId >= 0) {
            return this.getAllUsergroupsForAProject(projectId);
        }

        const allGroups = [];

        this.selectedProjects.map(project => {
            const usergroups = this.getAllUsergroupsForAProject(project.id, true);
            allGroups.push(...usergroups);
        });

        if (sorted) {
            return _.orderBy(allGroups, ['name'], ['asc']);
        }

        return allGroups;
    }

    prepareUserForAPI() {
        if (this.isLdap || this.isExternal) {
            this.password = "%UserPasswor6%";
            this.passwordConfirmation = "%UserPasswor6%";
        }

        if (this.isLdap) this.firstName = 'LDAP Role';
        if (this.isExternal) this.firstName = 'External User';

        const data = _.cloneDeep(this);

        delete data.availableProjects;
        delete data.isAuthUserSuperadmin;
        delete data.superAdminPrivilegegroup;

        delete data.active;
        delete data.activeProject;
        delete data.createdAt;
        delete data.updatedAt;
        delete data.cropperHeight;
        delete data.cropperImg;
        delete data.cropperOriginal;
        delete data.cropperWidth;
        delete data.cropperX;
        delete data.cropperY;
        // delete data.id;
        delete data.isDemo;
        delete data.lastLoginSupport;
        delete data.lastSeenAt;
        delete data.lastTransmittedLevelSupport;
        delete data.levels;
        delete data.profilePicture;
        delete data.removePicture;

        data.selectedProjects = this.selectedProjects.map(project => {
            const {usergroups, privilegegroups} = project;

            const onlyIdUsergroups =  usergroups.map(group => group.id);
            const onlyIdPrivilegegroups =  privilegegroups.map(group => group.id);

            return {
                name: project.name, id: project.id, usergroups: onlyIdUsergroups, privilegegroups: onlyIdPrivilegegroups
            };
        });

        return data;
    }

    selectAll(property) {
        if (property === 'selectedProjects') {
            this.selectedProjects = this.availableProjects
                .map(project => ({...project, selected: true}));
            return;
        }

        this.selectedProjects.forEach(project => {
            const availableGroups = this.availableProjects.find(ap => ap.id === project.id)[property];
            project[property] = availableGroups
                .map(group =>( {...group, selected: true}));
        });

        if ((property === 'privilegegroups') && this.isAuthUserSuperadmin) {
            this.isSuperadmin = true;
        }
    }

    deselectAll(property) {
        if (property === 'selectedProjects') {
            this[property] = [];
            return;
        }

        this.selectedProjects.forEach(project => {
            project[property].forEach(group => this.updateGroup(property,{...group, selected: false}));
        });

        if (property === 'privilegegroups') {
            this.isSuperadmin = false;
        }
    }
}
